import { gridSizeMdLg12, gridSizeMdLg5 } from "@/shared";
import { CustomTextFieldNoForm, TabTextLabel } from "@/shared/components/ui";
import { useAuthStore } from "@/store/auth";
import { Grid } from "@mui/material";


export default function TabDatosPerfil() {
    const userData = useAuthStore(s => s.user);
    console.log({userData})

    return (
    <>
        <Grid container>
            <Grid item >
                <Grid container item gap={2} spacing={2} {...gridSizeMdLg12}>
                    <TabTextLabel text="Datos Generales"/>
                    <CustomTextFieldNoForm
                        label="Nombre"
                        defaultValue={userData?.razon_social||"N/A"}
                        size={gridSizeMdLg5}
                        disabled={true}
                        sxTextField={{borderColor:"red"}}
                    />
                    <CustomTextFieldNoForm
                        label="Usuario"
                        defaultValue={userData?.username||"N/A"}
                        size={gridSizeMdLg5}
                        disabled={true}
                    />
                    <CustomTextFieldNoForm
                        label="Email"
                        defaultValue={userData?.email||"N/A"}
                        size={gridSizeMdLg5}
                        disabled={true}
                        sxTextField={{borderColor:"red"}}
                    />
                    <CustomTextFieldNoForm
                        label="Canal de Venta Principal"
                        defaultValue={userData?.canal_venta||"N/A"}
                        size={gridSizeMdLg5}
                        disabled={true}
                    />

                </Grid>
            </Grid>
        </Grid>
    </>
  )
}
